import joi from 'joi'
const SignUpSchema =joi.object({
    username: joi.string().min(3).max(50).required(),
    password: joi.string().min(8).max(60).required(),
    email: joi.string().min(8).required(),
    first_name: joi.string().max(25).required(),
    last_name:joi.string().max(25).required(),
    date_joined:joi.date()
}) ;

export default SignUpSchema;
